import { Table } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const CustomTable = styled(Table)`
  background: ${(props) => props.theme.colors['neutral-0']};
  border-radius: 12px;
  width: 100%;
  min-width: 700px;
  border: 0 none;
  overflow: hidden;

  & th:first-child,
  & td:first-child {
    border-left: 0 none;
  }

  & th:last-child,
  & td:last-child {
    border-right: 0 none;
  }

  & tr:last-child td {
    border-bottom: 0 none;
  }

  td {
    border: 1px solid hsla(0, 0%, 0%, 0.08);
    border-top: 0 none;
    padding: 16px 20px;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors['neutral-90']};
  }

  th {
    border: 1px solid hsla(0, 0%, 0%, 0.08);
    border-top: 0 none;
    padding: 14px 20px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.colors['neutral-70']};
  }

  & > thead {
    background-color: ${({ theme }) => theme.colors['neutral-20']};
  }

  & > tbody > tr {
    transition: background-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
    &:hover {
      background-color: ${({ theme }) => theme.colors['neutral-10']};
    }
  }

  ${media.mobile} {
    min-width: 500px;

    td {
      padding: 12px 12px;
      font-size: 13px;
    }

    th {
      padding: 10px 12px;
      font-size: 11px;
    }
  }
`;

export const TableLink = styled(Link)``;
